// @leyro/i18n · format.js
// Formatters compartidos entre web e mobile. Locale `gl-ES` por defecto.
//
// X-2.1.a: copia desde `apps/web/src/utils/formatters.js`. En X-2.1.b
// `apps/web` re-exportará destas funcións para evitar duplicación.

export const formatPrice = (value, decimals = 0, locale = "gl-ES") => {
  if (value == null || isNaN(value)) return "—";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const formatDate = (d, opts = {}, locale = "gl-ES") => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...opts,
  });
};

export const formatDateTime = (d, opts = {}, locale = "gl-ES") => {
  if (!d) return "—";
  return new Date(d).toLocaleString(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...opts,
  });
};

export const formatNumber = (value, opts = {}, locale = "gl-ES") => {
  if (value == null || isNaN(value)) return "—";
  return new Intl.NumberFormat(locale, opts).format(value);
};

// Relative time: "agora mesmo", "5 min", "3 h", "2 d", "5 sem", e despois formatDate.
// Pensado para timestamps de dispositivos, mensaxes de chat, conversas, etc.
export const formatRelativeTime = (d, locale = "gl-ES") => {
  if (!d) return "—";
  const date = new Date(d);
  const diffMs = Date.now() - date.getTime();
  if (Number.isNaN(diffMs)) return "—";

  const sec = Math.round(diffMs / 1000);
  const min = Math.round(diffMs / 60_000);
  const hr = Math.round(diffMs / 3_600_000);
  const day = Math.round(diffMs / 86_400_000);

  // Se é futuro, mostramos "data" curta.
  if (sec < 0) return formatDate(d, { day: "2-digit", month: "short" }, locale);

  if (sec < 45) return locale.startsWith("gl") ? "agora mesmo" : "ahora mismo";
  if (min < 60) return locale.startsWith("gl") ? `hai ${min} min` : `hace ${min} min`;
  if (hr < 24) return locale.startsWith("gl") ? `hai ${hr} h` : `hace ${hr} h`;
  if (day < 7) return locale.startsWith("gl") ? `hai ${day} d` : `hace ${day} d`;
  return formatDate(d, { day: "2-digit", month: "short" }, locale);
};
